import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

// Fallback defaults if Supabase is unreachable / row missing
const DEFAULTS = {
  event_date_display: 'May 20–23, 2027',
  event_location: 'Hemet, California',
  event_short_location: 'Hemet, CA',
  register_url: 'https://www.wetravel.com/trips/west-coast-marriage-camp-west-coast-ministries-5104053372',
  donate_url: 'https://www.zeffy.com/en-US/donation-form/west-coast-marriage-camp-donation',
  contact_phone: '(626) 536-2034',
  contact_email: 'westcoastmarriagecamp@gmail.com',
};

export function useSiteContent() {
  const [content, setContent] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const { data } = await supabase.from('wcmc_site_content').select('key, value');
    if (data) {
      const next = { ...DEFAULTS };
      data.forEach(row => { next[row.key] = row.value; });
      setContent(next);
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const updateKey = useCallback(async (key, value) => {
    const { error } = await supabase
      .from('wcmc_site_content')
      .update({ value, updated_at: new Date().toISOString() })
      .eq('key', key);
    if (!error) setContent(prev => ({ ...prev, [key]: value }));
    return { error };
  }, []);

  return { content, loading, updateKey, reload: load };
}
